"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var test_attributes_1 = require("@carvana/test-attributes");
var TextBadge_1 = __importDefault(require("./TextBadge"));
// TODO: deprecate in favor of individual components
var Badge = function (_a) {
    var children = _a.children, _b = _a.type, type = _b === void 0 ? 'text' : _b, _c = _a.priority, priority = _c === void 0 ? 'informational' : _c;
    var getTestAttributes = (0, test_attributes_1.useTestFunc)();
    if (type === 'text') {
        return ((0, jsx_runtime_1.jsx)(TextBadge_1.default, __assign({}, getTestAttributes('Badge'), { priority: priority }, { children: children })));
    }
    // TODO: other Badge types: 'icon'
    return null;
};
exports.Badge = Badge;
